import React from 'react';
import Typography from '@mui/material/Typography';

interface IRowProps {
  hit: any;
}

const ISOData: React.FC<IRowProps> = ({ hit }) => {
  return (
    <>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['ISO Control Family']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.ID}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source['Control Name']}
        </Typography>
      </div>
      <div className='hb-primary-col'>
        <Typography className='hb-primary-col-typo'>
          {hit._source.Description}
        </Typography>
      </div>
    </>
  );
};

export default ISOData;
